import { render, staticRenderFns } from "./BtzAccidents.vue?vue&type=template&id=03e428ac&scoped=true"
import script from "./BtzAccidents.vue?vue&type=script&lang=js"
export * from "./BtzAccidents.vue?vue&type=script&lang=js"
import style0 from "./BtzAccidents.vue?vue&type=style&index=0&id=03e428ac&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e428ac",
  null
  
)

export default component.exports